// extracted by mini-css-extract-plugin
module.exports = {"root":"NotFound__root--3SjPa"};